import { render, staticRenderFns } from "./LangPicker.vue?vue&type=template&id=34214575"
import script from "./LangPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./LangPicker.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports